var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatesection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#4B57E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6624 9.56289H10.9374V4.83789C10.9374 4.59626 10.7415 4.40039 10.4999 4.40039C10.2583 4.40039 10.0624 4.59626 10.0624 4.83789V9.56289H5.3374C5.09577 9.56289 4.8999 9.75876 4.8999 10.0004C4.8999 10.242 5.09577 10.4379 5.3374 10.4379H10.0624V15.1629C10.0624 15.4045 10.2583 15.6004 10.4999 15.6004C10.7415 15.6004 10.9374 15.4045 10.9374 15.1629V10.4379H15.6624C15.904 10.4379 16.0999 10.242 16.0999 10.0004C16.0999 9.75876 15.904 9.56289 15.6624 9.56289Z",
    fill: "#4B57E7",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatesection);
export default __webpack_public_path__ + "static/media/createsection.19be9f4afef958a8471ba4133ad29085.svg";
export { ForwardRef as ReactComponent };